export const PROJECT_SETTINGS = {
    supportPhone: '900300400'
};

export const DASHBOARD_STEPS = [
    {
        text: 'This App is your guide, <span>and the first step</span> of the <span>comprehensive</span> process of <span>qualifying for Social Security Disability Benefits.</span>'
    },
    {
        text: 'The questions that follow will allow the Attorneys at SSLG to assess your case. We will not ask you for any personal information like a SSN or DOB, but we will need your medical conditions and other information to properly assess. Once you complete this brief Wizard, your information will be e-mailed to a SSLG Intake Attorney who will contact you by phone within the same day. If it\'s late in the day, we\'ll call you tomorrow'
    },
    {
        text: 'Please note, this application requires your first name to start the process.   We also ask that you provide your e-mail address. This information is confidential and will not be used for any other purpose, other than to communicate with you. SSLG may ask you to provide us additional information, or we may e-mail you in the event we do not believe we can be effective in securing SSA benefits for you.'
    },
    {
        text: 'While it is our preference to have you complete this Wizard, if you prefer, you can contact us at<br><a href="tel:+18009097754">800-909-7754</a><br><br> We will be asking you all of questions in the Wizard. if you\'ve been denied in the last 60 Days, please locate your SSA denial prior to your call. There is coding we will need you to read to us'
    },
    {
        text: 'If SSLG believes you have a Reasonably Appropriate SSDI Case, and you sign the SSA forms and Medical Authorizations, etc. We will provide you access to Status Star and begin the process of either Filing a New Application for SSA Benefits or Appealing a Denial. What are you waiting for? Let\'s Go!'
    },
    {
        text: 'What kind of assistance are you seeking?'
    },
    {
        text: 'The questions that follow will allow SSLG to assess your appeal from a Medical and Vocational (past jobs) standpoint. In the follow-up steps, we will need the identity and contact information of your treating sources as well as approximate treatment dates, medications, etc. You can pause and return to this wizard at any time, using the one-time code we will send to your cell phone.'
    },
    {
        text: 'Before we go any further, we will need some critical coding that can be gleaned from your SSA denial.<br><br> Please locate your most recent SSA Denial. When you have it, select continue below'
    },
    {
        text: 'Please Provide us a detailed synopsis of your situation, and how we can help. We will review it and let you know if it\'s something we think we can effectively accomplish'
    },
    {
        text: 'Please review the TOP LEFT Corner of your decision'
    },
    {
        text: 'Please Provide us a detailed synopsis of your current work. What do you do? How many days a week? What is your Gross Pay? Why Can’t you work more hours? We will review and contact you.'
    }

];
